export const SET_LEADS_LIST = 'SET_LEADS_LIST';
export const UPDATE_LEADS_LIST = 'UPDATE_LEADS_LIST';
export const SET_INCORPORATION_LIST = 'SET_INCORPORATION_LIST';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';
